import React from 'react';
import { Typography, useMediaQuery, useTheme, Box } from '@mui/material';

const Home: React.FC = () => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Box textAlign='center'>
			<Typography variant={isMobile ? 'h4' : 'h3'} gutterBottom>
				Welcome to My Project
			</Typography>
			<Typography variant='body1'>This is the home page.</Typography>
		</Box>
	);
};

export default Home;
